<template>
  <div id="app" :class="mobflag==true?'mob':''">
    <Header v-if="mobflag==false" :far_nav="getnavIndex"  @getnav="getnav"/>
    <Header_m v-if="mobflag==true" :far_nav="getnavIndex"  @getnav="getnav"/>
    <router-view @getnav="getnav" />
    <Footer v-if="mobflag==false" :far_nav="getnavIndex" @getnav="getnav"/>
    <Footer_m v-if="mobflag==true" :far_nav="getnavIndex" @getnav="getnav"/>
  </div>
</template>
<script>

import Header from "./components/header";
import Footer from "./components/footer";
import Header_m from "./components/header_m";
import Footer_m from "./components/footer_m";

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Header_m,
    Footer_m,
  },
  metaInfo: {
    meta: [
      {charset: 'utf-8'},
      // {name: 'viewport', content: 'width=device-width,initial-scale=1, minimum-scale=0, maximum-scale=1,user-scalable=no'}
    ]
  },
  data(){
    return{
      getnavIndex:0,
      mobflag:false,
    }
  },
  created() {
    let abc = document.getElementsByTagName('body')[0]
    if (this._isMobile()) {
      this.mobflag=true
      let a=this.$route.path.slice(0,3)
      if(a!='/m/'){
        this.$router.push('/m/')
      }
      // abc.style.width = 1920+'px'
      // console.log(abc.style.width)
    }else{
      this.mobflag=false
      // let abc = document.getElementsByTagName('body')[0]
      let width = document.body.clientWidth / 1920
      abc.style.zoom = width
      // console.log(width)
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      // console.log(flag)
      return flag;
    },
    getnav(index){
      this.getnavIndex=index
      // console.log('getnavIndex:'+this.getnavIndex)
    }
  },
}
</script>

<style>
@import "assets/fonts/fonts.css";
@import "assets/css/style.less";
@import "assets/css/hovers.css";/*hover特效*/
@import "assets/css/init.css";
</style>
